import { render, staticRenderFns } from "./ProductSalesRecordTable.vue?vue&type=template&id=3d66e875&"
import script from "./ProductSalesRecordTable.vue?vue&type=script&lang=js&"
export * from "./ProductSalesRecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports